import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { reservasAPI, cobranzasAPI } from "../../../utils/funcionesAPI";
import { manejadorDeRespuesta } from "../../../utils/Tools";
import CuadroResumen from "../CuadroResumen";
import LoaderFormal from "../../Global/LoaderFormal";
import { toast, ToastContainer } from "react-toastify";
import TarjetasBancoCuotasPedraza from "../../Global/TarjetasBancoCuotasPedraza";
import TotalConTarjeta from "../../Global/TotalConTarjeta";
import PaymentForm from "../../Global/PaymentForms";
import check from "../../../imagenes/thanks/check.png";
import check2x from "../../../imagenes/thanks/check@2x.png";
import cruz from "../../../imagenes/thanks/cruz.png";
import cruz2x from "../../../imagenes/thanks/cruz@2x.png";
//import imgSmall from "../../../imagenes/sobrePedraza/img-small-2.png";
//import imgSmall2x from "../../../imagenes/sobrePedraza/img-small-2@2x.png";
import NumberFormat from "react-number-format";

const Prisma = (props) => {
  const [reserva, setReserva] = useState({
    charter: {},
    producto: {
      destino: {},
      moneda: {
        cotizacion: 1,
        codigoMoneda: "PES",
      },
    },
  });

  const [datosTarjeta, setDatosTarjeta] = useState({
    numeroTarjeta: "",
    mesExp: "",
    anioExp: "",
    cvc: "",
    cardHolderName: "",
    focus: "",
    tipoDocumento: {
      idTipoDocumento: "1",
      sigla: "DNI",
    },
    numeroDocumento: "",
    email: "",
  });

  const [importe, setImporte] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [tarjetaElegida, setTarjetaElegida] = useState({});
  const [cuotaElegida, setCuotaElegida] = useState({ interes: 0 });
  const [importeProporcionalRGPais, setImporteProporcionalRGPais] = useState(0);
  const [bancoElegido, setBancoElegido] = useState({});
  //const [errorFirstData, setErrorFirstData] = useState("");
  const [resultado, setResultado] = useState("");
  const [motivo, setMotivo] = useState("");
  const token = sessionStorage.getItem("token");
  const user = sessionStorage.getItem("usuario");
  const tipoCliente = sessionStorage.getItem("tipoCliente");

  if (!token && !user) {
    props.history.push("/login");
  }

  const estado = props.match.params.estado;

  useEffect(() => {
    if (estado === "success") {
      toast.success(
        "El Pago ha sido procesado. En la proximas horas su saldo será actualizado. Aguarde unos instantes y será redirigido al panel de Mis Reservas.",
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 8000,
          onClose: () => {
            window.location.href = "https://pedraza.com.ar/panel-mis-reservas";
            return null;
          },
        }
      );
    } else if (estado === "error") {
      const data = JSON.stringify({
        peticion: "traerMensajeErrorFirstData",
        numeroReserva: props.match.params.nroReserva,
      });
      cobranzasAPI(data).then((respuesta) => {
        if (manejadorDeRespuesta(props, respuesta)) {
          //setErrorFirstData(`: ${respuesta.data}`);
          toast.error(
            `Ha ocurrido un error durante el pago por: ${respuesta.data}. Aguarde unos instantes y será redirigido al panel de Mis Reservas.`,
            {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 8000,
              onClose: () => {
                window.location.href =
                  "https://pedraza.com.ar/panel-mis-reservas";
                return null;
              },
            }
          );
        }
      });
    }
  }, [estado]);

  const traerReservaPorNumero = (numeroReserva) => {
    const data = JSON.stringify({
      peticion: "traerReservaPorNumero",
      token: token,
      numeroReserva,
    });

    setLoaded(true);

    reservasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) setLoaded(false);

      setReserva(respuesta.data);
      setImporte(
        Math.ceil(
          respuesta.data.saldo * respuesta.data.producto.moneda.cotizacion
        )
      );
    });
  };

  /*
  const mostrarMensajeResultado = (estadoElegido) => {
    let mensaje = "";
    switch (estadoElegido) {
      case "success":
        mensaje = (
          <span className="textoConfirmada">
            El Pago ha sido procesado. En la proximas horas su saldo será
            actualizado.
          </span>
        );
        break;
      case "error":
        mensaje = (
          <span className="textoCancelada">
            Ha ocurrido un error durante el pago
          </span>
        );
        break;
      default:
        break;
    }

    return mensaje;
  };
*/
  useEffect(() => {
    traerReservaPorNumero(props.match.params.nroReserva);
  }, [props.match.params.nroReserva]);

  const handleTarjetaClick = (tarjetaEleg, cuotaElegida) => {
    setTarjetaElegida(tarjetaEleg);
    setCuotaElegida(cuotaElegida);
  };

  const handleBancoClick = (banco) => {
    setBancoElegido(banco);
  };

  const handleCuotaClick = (cuotaEleg) => {
    setCuotaElegida(cuotaEleg);
  };

  const handleDatosTarjetaChange = (evt) => {
    const { name, value } = evt.target;
    setDatosTarjeta((prev) => ({ ...prev, [name]: value }));
  };

  const handlePagoChange = (e) => {
    if (e.target.value === "") return;
    const numberWithoutDot = e.target.value.replaceAll(",", "");
    setImporte(numberWithoutDot);
    handleRecalcularProporcionalImpuesto(numberWithoutDot);
  };

  const handleRecalcularProporcionalImpuesto = (importe) => {
    if (reserva.producto.impuestoPAIS.coeficiente === 0) {
      const coefTasa =
        1 -
        reserva.charter.tarifa.importeNoComisionable /
          reserva.charter.tarifa.tarifa;
      const coefRG = reserva.producto.impuestoPAIS.valor / 100;
      const coefBaseImponible = 1; //forzado
      const coefAplicacion =
        parseFloat(coefTasa.toFixed(6)) * coefRG * coefBaseImponible;
      const coefAplicar = 1 + coefAplicacion;
      //importeQuePaga = Es el importe que tipea el cliente que quiere pagar. No menos del 30% del total del viaje

      //ProcentajePais = Es el porcentaje de la RG que se debe aplicar obtenida del query
      //const infoas = despejarInfoas(this.props.pasajerosMenores);//function en Tools
      //const pasajerosPagantes = this.props.pasajerosAdultos.length + this.props.pasajerosMenores.length - infoas;

      const importeProporcionalRGPais = importe - importe / coefAplicar;

      //const importeRGPaisPQ = importeRGPaisCL / cot_PQ;//  (por si necestias tener el valor en moneda del Paquete)
      //Este importe importeRGPaisCL  es que se suma al importeQuePaga y es el que viaja a FirstData
      //const importeFirstFData =  this.state.importeAPagarConImpuestosYIntereses + importeProporcionalRGPais;
      setImporteProporcionalRGPais(importeProporcionalRGPais);
    }
  };

  const handlePagarConFirstDataClick = (e) => {
    e.preventDefault();

    if (!importe) {
      toast.info("Debe ingresar un importe.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    const {
      numeroTarjeta,
      mesExp,
      anioExp,
      cvc,
      cardHolderName,
      numeroDocumento,
      email,
    } = datosTarjeta;

    if (
      numeroTarjeta === "" ||
      mesExp === "" ||
      anioExp === "" ||
      cvc === "" ||
      cardHolderName === "" ||
      numeroDocumento === "" ||
      email === "" ||
      !bancoElegido.id ||
      !tarjetaElegida.id ||
      !cuotaElegida.cantidad
    ) {
      toast.info("Debe comlpetar todos los campos de la tarjeta", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (
      !reserva.pasajeros.some((pax) => pax.documento === numeroDocumento) &&
      tipoCliente === "IND"
    ) {
      toast.info(
        "Los datos de la tarjeta ingresados, no coinciden con los datos de alguno de los pasajeros. Si desea abonar con una tarjeta de terceros deberá acercarse a alguna de nuestras sucursales.",
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      return;
    }
    /*
    const interes =
      parseFloat(importe) * parseFloat(cuotaElegida.interes / 100);
*/
    const pagoElectronico = {
      numeroReserva: reserva.numeroReserva,
      canal: "WEB",
      //intereses: interes,
      totalPagar: importe,
      datosTarjeta,
      tarjetaElegida,
      cuotaElegida,
      bancoElegido,
      producto: reserva.producto,
    };

    const data = JSON.stringify({
      peticion: "prisma",
      token: token,
      pagoElectronico,
    });

    setLoaded(true);
    setResultado("");
    setMotivo("");

    cobranzasAPI(data).then((respuesta) => {
      setLoaded(false);
      if (manejadorDeRespuesta(props, respuesta)) {
        setResultado("success");
        //window.location.href = `https://pedraza.com.ar/panel-mis-reservas/prisma/mensaje/${reserva.numeroReserva}/success`;
      } else {
        setResultado("error");
        setMotivo(respuesta.mensaje);
      }
      //window.location.href = `https://pedraza.com.ar/panel-mis-reservas/prisma/mensaje/${reserva.numeroReserva}/error`;
    });
  };

  return (
    <section className="reservas">
      <div className="container-fluid" style={{ backgroundColor: "#181e35" }}>
        <div className="row">
          <LoaderFormal loaded={loaded} />
          <h1 style={{ color: "white" }}>Pagar con Tarjeta de Crédito</h1>
          <hr />

          <CuadroResumen reserva={reserva} />
        </div>
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="containter position-relative">
              <form>
                <div className="form-group d-inline-block col-xl-8 col-lg-5 col-md-5 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="importe">
                    Ingresar Importe (usar el punto "." para ingresar decimales)
                  </label>
                  <NumberFormat
                    value={importe}
                    className="form-control"
                    name="importe"
                    displayType={"input"}
                    thousandSeparator=","
                    allowNegative={false}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    decimalSeparator="."
                    onChange={handlePagoChange}
                  />
                  <TarjetasBancoCuotasPedraza
                    cuotaElegida={cuotaElegida}
                    tarjetaElegida={tarjetaElegida}
                    onTarjetaClick={handleTarjetaClick}
                    onBancoClick={handleBancoClick}
                    onCuotaClick={handleCuotaClick}
                    producto={reserva.producto}
                    fechaSalida={reserva.charter.fechaSalida}
                  />
                </div>
              </form>
            </div>
          </div>

          <div className="col-xl-6 col-lg-3 col-md-6 col-sm-12 col-12">
            <section className="position-relative py-6 py-xl-4 py-lg-6 py-md-4 py-sm-3">
              <div className="container position-relative">
                <div className="row d-flex ">
                  <PaymentForm
                    datosTarjeta={datosTarjeta}
                    onHandleDatosTarjetaChange={handleDatosTarjetaChange}
                  ></PaymentForm>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className="row" style={{ padding: "10px 0" }}>
          <div className="content col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <section className="checkout-steps position-relative">
              <div className="container">
                <div className="row">
                  <div className="content col-xl-12 col-lg-12 col-md-8 col-sm-12 col-12">
                    <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 payment clearfix">
                      <TotalConTarjeta
                        cuotaElegida={cuotaElegida}
                        totalPaquete={
                          reserva.saldo * reserva.producto.moneda.cotizacion
                        }
                        impuestoPais="0"
                        importeAPagar={importe}
                        importeProporcionalRGPais={importeProporcionalRGPais}
                      />
                    </section>
                  </div>
                </div>
              </div>
            </section>

            <p className="contenedorLinkInicio col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
              {resultado !== "success" ? (
                <input
                  className="botonInicio"
                  type="submit"
                  value="Pagar"
                  onClick={handlePagarConFirstDataClick}
                />
              ) : (
                <Link className="botonInicio" to="/panel-mis-reservas">
                  Volver al Panel
                </Link>
              )}
            </p>

            {resultado && (
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 thanks clearfix">
                {resultado === "success" ? (
                  <img
                    src={check}
                    alt="Icono de un check"
                    srcSet={check + " 1x, " + check2x + " 2x"}
                  />
                ) : (
                  <img
                    src={cruz}
                    alt="Icono de un check"
                    srcSet={cruz + " 1x, " + cruz2x + " 2x"}
                  />
                )}
                <h2
                  className={
                    resultado === "success" ? "mensajeExito" : "mensajeError"
                  }
                >
                  {resultado === "success" ? "Pago Exitoso" : `${motivo}`}
                </h2>
              </div>
            )}

            <div className="listado">
              <Link style={{ color: "#fff" }} to="/panel-mis-reservas">
                Volver al Panel
              </Link>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </section>
  );
};

export default Prisma;



// WEBPACK FOOTER //
// ./src/components/MisReservas/Prisma/index.js